var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDispatch } from 'react-redux';
import { apiUpdateRfpQuestionLog } from '@/actions/ProfessionalRfpQuestionActions';
import { useDidMount } from '@/hooks/lifecycle/useDidMount';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * 未読の質問を既読に更新
 */
export const useRfpProfessionalQuestionListUpdateUnread = (args) => {
    const { id, onlineQuestions } = args;
    const dispatch = useDispatch();
    useDidMount(() => {
        const unreadQuestionIds = onlineQuestions
            .filter((q) => q.is_unread)
            .map((q) => q.id);
        // 未読の質問がない場合
        if (unreadQuestionIds.length <= 0) {
            return;
        }
        // 未読の質問を既読に更新
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield wrapDispatch(dispatch, apiUpdateRfpQuestionLog({
                    json: { id: unreadQuestionIds },
                    path: { id },
                }, {}));
            }
            catch (e) {
                // エラーは表示しない
            }
        }))();
    });
};
